import { ChannelState, PaginationInfo } from './state';
import { ActionTree } from 'vuex';
import { normalize } from 'normalizr';
import RootState from '@/store/root_state';
import { forumQuery } from '@/helpers/graphql';
import {
  channelsByIdQuery,
  channelInfoByIdQuery,
  paginatedChannelInfoByIdQuery,
} from '@/store/queries/forumAPIQueries';
import { channel as channelSchema } from '../forum_api_normalizr_schema';

const actions: ActionTree<ChannelState, RootState> = {
  async PULL_FORUM_API_CHANNELS(
    { commit, dispatch },
    { courseId, channelIdList }: { courseId: any; channelIdList: string[] },
  ) {
    const {
      data: { channels: rawChannels },
    } = await forumQuery(channelsByIdQuery, { channelIdList });

    const channelsData = {
      channels: rawChannels.map((channel: any) => {
        return { ...channel, courseId };
      }),
    };

    const normalizedResponse = normalize(channelsData, { channels: [channelSchema] });

    commit('SET_FORUM_API_CHANNELS', normalizedResponse.entities);

    channelIdList.forEach((channelId: string) =>
      dispatch('PULL_FORUM_API_CHANNEL_INFO', { channelId }),
    );
  },

  async PULL_FORUM_API_CHANNEL_INFO(
    { commit },
    {
      channelId,
      orderByDesc,
      first,
      skip,
    }: {
      channelId: string;
      orderByDesc: boolean | undefined;
      first: number | undefined;
      skip: number | undefined;
    },
  ) {
    if (!channelId) return;

    const isPaginated = orderByDesc !== undefined && first !== undefined && skip !== undefined;

    if (isPaginated) {
      const orderBy = orderByDesc ? 'createdAt_DESC' : 'createdAt_ASC';

      const response = await forumQuery(paginatedChannelInfoByIdQuery, {
        channelId,
        orderBy,
        first,
        skip,
      });

      if (!response.data.discussionsConnection) return;

      const { pageInfo, aggregate, edges } = response.data.discussionsConnection;
      pageInfo.numberOfItems = aggregate.count;
      pageInfo.totalNumberOfPages = Math.ceil(aggregate.count / pageInfo.pageSize);

      const paginationData: PaginationInfo = pageInfo;

      const channelData = {
        channel: {
          discussions: edges.map((discussion: any) => discussion.node),
        },
      };
      const normalizedResponse = normalize(channelData, {
        channel: channelSchema,
      });

      commit('SET_FORUM_API_PAGINATION_INFO', paginationData);
      commit('SET_FORUM_API_PAGINATED_DISCUSSIONS', normalizedResponse.entities);
      commit('SET_FORUM_API_COMMENTS', normalizedResponse.entities);
      return;
    }

    const response = await forumQuery(channelInfoByIdQuery, { channelId });

    const normalizedResponse = normalize(response.data, {
      channel: channelSchema,
    });

    commit('SET_FORUM_API_DISCUSSIONS', normalizedResponse.entities);
    commit('SET_FORUM_API_COMMENTS', normalizedResponse.entities);
  },
};

export default actions;
